module.exports = __webpack_public_path__ + "img/腳色介面_01-選擇1.a4ea3719.png";